import {CSSProperties} from '../../../styleSheet';
import {BaseFlexProps} from '../types';

export const buildFlexStyle = ({
  justify,
  align,
  centered,
  alignSelf,
  flex,
}: BaseFlexProps = {}): CSSProperties => {
  return {
    ...(justify ? {justifyContent: justify} : {}),
    ...(align ? {alignItems: align} : {}),
    ...(centered ? {alignItems: 'center', justifyContent: 'center'} : {}),
    ...(alignSelf ? {alignSelf: alignSelf} : {}),
    ...(flex ? {flex: flex === true ? '1' : flex} : {}),
  };
};
